// Mapper: transport LC_GetMyTeamMonthlyMarksSummaryOut → domain model for the
// "Mi equipo" dashboard "Resumen del mes" — "Marcajes" card (ASIS-5412 / REXASIS-011).
// The backend only sends the raw counts + the cutoff's date range; percentageInPerson is
// computed here, and percentageRemote is its exact complement (not computed independently)
// so both always add up to 100 — unlike the other 3 monthly cards, this is a single
// exhaustive split of one count, not two counts from different subsystems, so there's no
// approved/total mismatch to guard against.

import type {
  LC_GetMyTeamMonthlyMarksSummaryOut,
  MyTeamMonthlyMarksSummary,
} from '../types/myTeamMonthlyMarksSummary.types';


export function mapMyTeamMonthlyMarksSummary(
  out: LC_GetMyTeamMonthlyMarksSummaryOut,
): MyTeamMonthlyMarksSummary {
  const totalMarksCount = out.inPersonCount + out.remoteCount;
  const isEmpty = totalMarksCount === 0;
  const percentageInPerson = isEmpty
    ? 0
    : Math.round((out.inPersonCount / totalMarksCount) * 100);
  const percentageRemote = isEmpty ? 0 : 100 - percentageInPerson;

  return {
    inPersonCount: out.inPersonCount,
    remoteCount: out.remoteCount,
    dateFrom: out.dateFrom,
    dateTo: out.dateTo,
    percentageInPerson,
    percentageRemote,
    isEmpty,
  };
}
